export const ServeManageRoutes = [
  {
    path: "/Admin/ServeManage/connectUs",
    name: "联系我们",
    component: () => import("./connectUs/index.vue"),
    meta: {
      title: "联系我们"
    }
  }
];



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/ServeManage/routes.js